import script from "./AuditLogPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditLogPage.vue?vue&type=script&setup=true&lang=js"

import "./AuditLogPage.vue?vue&type=style&index=0&id=7e4c819a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e4c819a"]])

export default __exports__